import { Action } from 'redux';

export { isLoading, doneLoading } from 'store/config/actions';

// --- Action Types ---

// All actions related to generating a new blank lot.
export const GENERATE_LOT = 'lots/GENERATE_LOT';
export interface GenerateLotAction extends Action<typeof GENERATE_LOT> {}

// All actions related to clearing the Lots state
export const CLEAR_LOTS = 'lots/CLEAR_LOTS';
export interface ClearLotsAction extends Action<typeof CLEAR_LOTS> {}

// All actions related to creating a brand new lot.
export const CREATE_LOT = 'lots/CREATE_LOT';
export interface CreateLotAction extends Action<typeof CREATE_LOT> {
  readonly payload: ParkingLot;
}

// All actions related to editing an existing lot
export const EDIT_LOT = 'lots/EDIT_LOT';
export interface EditLotAction extends Action<typeof EDIT_LOT> {
  readonly payload: ParkingLot;
}

// All actions related to doing a lookup of a single lot
export const LOOKUP_LOT = 'lots/LOOKUP_LOT';
export interface LookupLotAction extends Action<typeof LOOKUP_LOT> {
  readonly payload: number | string;
}

export const LOOKUP_LOT_COMPLETE = 'lots/LOOKUP_LOT_COMPLETE';
export interface LookupLotCompleteAction extends Action<typeof LOOKUP_LOT_COMPLETE> {
  readonly payload: {
    readonly data: ParkingLot;
    readonly etag?: string;
  };
}

// All actions related to doing a lookup of multiple lots
export const LOOKUP_LOTS = 'lots/LOOKUP_LOTS';
export interface LookupLotsAction extends Action<typeof LOOKUP_LOTS> {}

export const LOOKUP_LOTS_COMPLETE = 'lots/LOOKUP_LOTS_COMPLETE';
export interface LookupLotsCompleteAction extends Action<typeof LOOKUP_LOTS_COMPLETE> {
  readonly payload: ReadonlyArray<ParkingLot>;
}

// All actions related to deleting an existing lot
export const DELETE_LOT = 'lots/DELETE_LOT';
export interface DeleteLotAction extends Action<typeof DELETE_LOT> {
  readonly payload: ParkingLot;
}

export const DELETE_LOT_COMPLETE = 'lots/DELETE_LOT_COMPLETE';
export interface DeleteLotCompleteAction extends Action<typeof DELETE_LOT_COMPLETE> {}

export type LotAction =
  | GenerateLotAction
  | ClearLotsAction
  | CreateLotAction
  | EditLotAction
  | LookupLotAction
  | LookupLotCompleteAction
  | LookupLotsAction
  | LookupLotsCompleteAction
  | DeleteLotAction
  | DeleteLotCompleteAction;

// --- Actions ---
export const generateLot = (): GenerateLotAction => ({ type: GENERATE_LOT });
export const clearLots = (): ClearLotsAction => ({ type: CLEAR_LOTS });
export const createLot = (lot: ParkingLot): CreateLotAction => ({ payload: lot, type: CREATE_LOT });
export const editLot = (lot: ParkingLot): EditLotAction => ({ payload: lot, type: EDIT_LOT });
export const lookupLot = (id: number | string): LookupLotAction => ({
  payload: id,
  type: LOOKUP_LOT,
});
export const lookupLotComplete = (data: LookupLotCompleteAction['payload']): LookupLotCompleteAction => ({
  payload: data,
  type: LOOKUP_LOT_COMPLETE,
});
export const lookupLots = (): LookupLotsAction => ({ type: LOOKUP_LOTS });
export const lookupLotsComplete = (lots: ReadonlyArray<ParkingLot>): LookupLotsCompleteAction => ({
  payload: lots,
  type: LOOKUP_LOTS_COMPLETE,
});
export const deleteLot = (lot: ParkingLot): DeleteLotAction => ({ payload: lot, type: DELETE_LOT });
export const deleteLotComplete = (): DeleteLotCompleteAction => ({ type: DELETE_LOT_COMPLETE });
